module.exports = __webpack_public_path__ + "img/shinhan.b6367aeb.png";